(function () {
  "use strict";

  var PRODUCT_ID = "8290676146359";
  var OFFER_ID = "1167597";

  function toStringId(value) {
    return String(value == null ? "" : value);
  }

  class LTBCCalendarPickerV40 extends HTMLElement {
    connectedCallback() {
      if (this.started) return;

      this.started = true;
      this.ready = false;
      this.busy = false;
      this.removed = false;
      this.addonSelected = false;
      this.hiddenNative = new Set();

      var configNode = this.querySelector("[data-ltbc-config]");

      if (!configNode) return;

      try {
        this.config = JSON.parse(configNode.textContent);
      } catch (error) {
        this.fail("The calendar picker could not load.");
        console.error("LTBC picker config error:", error);
        return;
      }

      if (toStringId(this.config.productId) !== PRODUCT_ID) return;

      this.variants = Array.isArray(this.config.variants)
        ? this.config.variants.filter(
            function (variant) {
              return Number(variant.price) === Number(this.config.basePrice);
            }.bind(this)
          )
        : [];

      this.availableVariants = this.variants.filter(function (variant) {
        return !!variant.available;
      });

      if (!this.availableVariants.length) {
        this.fail("This calendar is currently unavailable.");
        return;
      }

      this.money = new Intl.NumberFormat(
        this.config.locale || "en-US",
        {
          style: "currency",
          currency: this.config.currency,
          currencyDisplay: "narrowSymbol",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      );

      this.querySelectorAll("[data-currency]").forEach(
        function (node) {
          node.textContent = this.config.currency;
        }.bind(this)
      );

      var defaults = this.getDefaultCovers();

      this.selections = {
        single: [defaults.first.id],

        pair: [
          defaults.first.id,
          defaults.second.id
        ],

        four: [
          defaults.first.id,
          defaults.second.id,
          defaults.first.id,
          defaults.second.id
        ],

        six: [
          defaults.first.id,
          defaults.second.id,
          defaults.first.id,
          defaults.second.id,
          defaults.first.id,
          defaults.second.id
        ]
      };

      var cartLink = this.querySelector("[data-cart-link]");

      if (cartLink) {
        cartLink.href = this.config.cartUrl || "/cart";
      }

      this.buildCoverSelectors();
      this.updateImages();
      this.setupAddon();
      this.bindEvents();

      this.hideVitalsVisual();

      this.observer = new MutationObserver(
        function () {
          this.hideVitalsVisual();

          if (!this.ready) {
            this.tryPrices();
          }
        }.bind(this)
      );

      this.observer.observe(
        document.documentElement,
        {
          childList: true,
          subtree: true
        }
      );

      this.priceAttempts = 0;
      this.waitForPrices();
    }

    bindEvents() {
      this.changeHandler =
        function (event) {
          var target = event.target;

          if (target.matches("[data-cover-select]")) {
            var group = target.getAttribute("data-group");
            var index = Number(target.getAttribute("data-index"));

            if (this.selections[group] && Number.isInteger(index)) {
              this.selections[group][index] = target.value;
              this.updateImages();
              this.clearStatus();
            }
          }

          if (target.matches("[data-addon-checkbox]")) {
            this.addonSelected = target.checked;
            this.clearStatus();
          }
        }.bind(this);

      this.clickHandler =
        function (event) {
          var button = event.target.closest("[data-buy]");

          if (!button || button.disabled) return;

          this.buy(
            Number(
              button.getAttribute("data-buy")
            )
          );
        }.bind(this);

      this.addEventListener("change", this.changeHandler);
      this.addEventListener("click", this.clickHandler);
    }

    getDefaultCovers() {
      var first =
        this.availableVariants.find(function (variant) {
          return toStringId(variant.id) === "49389592674487";
        }) ||

        this.availableVariants.find(function (variant) {
          return /golden hour/i.test(variant.title || "");
        }) ||

        this.availableVariants[0];

      var second =
        this.availableVariants.find(function (variant) {
          return toStringId(variant.id) === "49389592707255";
        }) ||

        this.availableVariants.find(function (variant) {
          return /wildflower/i.test(variant.title || "");
        }) ||

        this.availableVariants.find(function (variant) {
          return toStringId(variant.id) !== toStringId(first.id);
        }) ||

        first;

      return {
        first: first,
        second: second
      };
    }

    getVariant(id) {
      return this.variants.find(function (variant) {
        return toStringId(variant.id) === toStringId(id);
      });
    }

    buildCoverSelectors() {
      ["single", "pair", "four", "six"].forEach(
        function (group) {
          var container = this.querySelector(
            '[data-selects="' + group + '"]'
          );

          if (!container) return;

          container.innerHTML = "";

          this.selections[group].forEach(
            function (selectedId, index) {
              var label = document.createElement("label");

              label.className = "ltbc40-select-label";

              label.appendChild(
                document.createTextNode(
                  group === "single"
                    ? "Choose your cover"
                    : "Calendar " + (index + 1)
                )
              );

              var select = document.createElement("select");

              select.setAttribute("data-cover-select", "");
              select.setAttribute("data-group", group);
              select.setAttribute("data-index", String(index));

              this.variants.forEach(function (variant) {
                var option = document.createElement("option");

                option.value = String(variant.id);

                option.textContent =
                  variant.title === "Default Title"
                    ? "Golden Hour, Potty Power"
                    : variant.title;

                if (!variant.available) {
                  option.disabled = true;
                  option.textContent += " — sold out";
                }

                select.appendChild(option);
              });

              select.value = String(selectedId);

              label.appendChild(select);
              container.appendChild(label);
            }.bind(this)
          );
        }.bind(this)
      );
    }

    coverImage(variant) {
      if (
        toStringId(variant.id) ===
        "49389592674487"
      ) {
        return "https://cdn.shopify.com/s/files/1/0719/8103/9799/files/S7c313fd33f524090b7b4a7fad0eab759U.avif?v=1790015866";
      }

      if (
        toStringId(variant.id) ===
        "49389592707255"
      ) {
        return "https://cdn.shopify.com/s/files/1/0719/8103/9799/files/S5793313f19d04b3fa46a985c41256e96w_jpg.avif?v=1792269824";
      }

      return (
        variant.image ||
        this.config.featuredImage ||
        ""
      );
    }

    updateImages() {
      this.querySelectorAll("[data-preview]").forEach(
        function (image) {
          var parts = image
            .getAttribute("data-preview")
            .split("-");

          var group = parts[0];
          var index = Number(parts[1]);

          var selection =
            this.selections[group];

          if (!selection) return;

          var variant =
            this.getVariant(
              selection[
                index % selection.length
              ]
            );

          if (!variant) return;

          image.src =
            this.coverImage(variant);

          image.alt =
            (variant.title || "Selected") +
            " calendar cover";
        }.bind(this)
      );

      this.updateMix("single", 1);
      this.updateMix("pair", 2);
      this.updateMix("four", 4);
      this.updateMix("six", 6);
    }

    updateMix(group, quantity) {
      var names = [];

      this.selections[group].forEach(
        function (id) {
          var variant = this.getVariant(id);

          if (!variant) return;

          var name =
            variant.title || "Cover";

          if (/golden hour/i.test(name)) {
            name = "Golden Hour";
          }

          if (/wildflower/i.test(name)) {
            name = "Wildflowers";
          }

          if (names.indexOf(name) === -1) {
            names.push(name);
          }
        }.bind(this)
      );

      var node =
        this.querySelector(
          '[data-mix="' +
          quantity +
          '"]'
        );

      if (node) {
        node.textContent =
          names.length === 1
            ? names[0]
            : "Mixed covers";
      }
    }

    setupAddon() {
      var addon = this.config.addon;

      var box =
        this.querySelector(
          "[data-addon]"
        );

      if (!box) return;

      if (
        !addon ||
        !addon.available ||
        !addon.variantId ||
        !addon.basePrice ||
        Number(addon.discountPercent) !== 20
      ) {
        box.hidden = true;
        return;
      }

      this.addonExpectedTotal =
        Math.round(
          Number(addon.basePrice) *
          0.8
        );

      var image =
        this.querySelector(
          "[data-addon-image]"
        );

      var sale =
        this.querySelector(
          "[data-addon-sale]"
        );

      var regular =
        this.querySelector(
          "[data-addon-regular]"
        );

      if (image) {
        image.src = addon.image || "";
      }

      if (sale) {
        sale.textContent =
          "+" +
          this.formatMoney(
            this.addonExpectedTotal
          );
      }

      if (regular) {
        regular.textContent =
          this.formatMoney(
            addon.basePrice
          );
      }

      box.hidden = false;
    }

    findVitalsWidget() {
      var offerId =
        String(
          this.config.vitalsOfferId ||
          OFFER_ID
        );

      var radio =
        document.getElementById(
          "vtl-vd-radio-name-" +
          offerId
        );

      if (radio) {
        var fromRadio =
          radio.closest(
            ".vtl-ub-vd-widget"
          ) ||
          radio.closest(
            "[data-track-ed-oid]"
          );

        if (fromRadio) {
          return fromRadio;
        }
      }

      var offerNode =
        document.querySelector(
          '[data-track-ed-oid="' +
          offerId +
          '"]'
        );

      if (offerNode) {
        return (
          offerNode.closest(
            ".vtl-ub-vd-widget"
          ) ||
          offerNode
        );
      }

      return null;
    }

    hideVitalsVisual() {
      var widget =
        this.findVitalsWidget();

      if (widget) {
        widget.classList.add(
          "ltbc40-vitals-source-hidden"
        );
      }
    }

    waitForPrices() {
      if (
        this.removed ||
        this.ready
      ) {
        return;
      }

      this.priceAttempts += 1;

      this.hideVitalsVisual();

      if (this.tryPrices()) {
        return;
      }

      if (this.priceAttempts < 80) {
        this.priceTimer =
          setTimeout(
            function () {
              this.waitForPrices();
            }.bind(this),
            500
          );
      } else {
        var loader =
          this.querySelector(
            "[data-loader]"
          );

        if (loader) {
          loader.innerHTML =
            "<strong>Still syncing current prices…</strong><br>The regular purchase controls remain available.";
        }
      }
    }

    tryPrices() {
      if (this.ready) {
        return true;
      }

      var widget =
        this.findVitalsWidget();

      if (!widget) {
        return false;
      }

      var tiers =
        widget.querySelectorAll(
          '[data-vtl-el="tier"]'
        );

      if (!tiers.length) {
        return false;
      }

      var prices = {};

      tiers.forEach(
        function (tier) {
          var quantityNode =
            tier.querySelector(
              ".Vtl-NewVolumeDiscountRadio__LabelHeaderQuantity"
            );

          var priceNode =
            tier.querySelector(
              '[data-vtl-el="price"]'
            );

          if (
            !quantityNode ||
            !priceNode
          ) {
            return;
          }

          var quantity =
            this.readQuantity(
              quantityNode.textContent
            );

          var total =
            this.readMoney(
              priceNode.textContent
            );

          if (
            [2, 4, 6].indexOf(quantity) ===
            -1
          ) {
            return;
          }

          if (
            !Number.isSafeInteger(total) ||
            total <= 0
          ) {
            return;
          }

          var regularTotal =
            Number(
              this.config.basePrice
            ) *
            quantity;

          if (total > regularTotal) {
            return;
          }

          prices[quantity] = total;
        }.bind(this)
      );

      if (
        !prices[2] ||
        !prices[4] ||
        !prices[6]
      ) {
        return false;
      }

      if (
        prices[4] < prices[2] ||
        prices[6] < prices[4]
      ) {
        return false;
      }

      this.prices = {
        1: Number(
          this.config.basePrice
        ),
        2: prices[2],
        4: prices[4],
        6: prices[6]
      };

      this.ready = true;

      this.setAttribute(
        "data-ltbc-state",
        "ready"
      );

      document.body.classList.add(
        "ltbc40-picker-ready"
      );

      var loader =
        this.querySelector(
          "[data-loader]"
        );

      if (loader) {
        loader.hidden = true;
      }

      this.renderPrices();
      this.enableButtons();
      this.hideNativeControls();

      clearTimeout(
        this.priceTimer
      );

      return true;
    }

    readQuantity(text) {
      if (!text) return null;

      var match =
        String(text).match(
          /\b(2|4|6)\b/
        );

      return match
        ? Number(match[1])
        : null;
    }

    readMoney(text) {
      if (!text) return null;

      var value =
        String(text)
          .replace(
            /[^0-9.,]/g,
            ""
          )
          .trim();

      if (!value) return null;

      var decimalMatch =
        value.match(
          /[.,]([0-9]{2})$/
        );

      if (decimalMatch) {
        var whole =
          value
            .slice(0, -3)
            .replace(
              /[.,]/g,
              ""
            );

        value =
          whole +
          "." +
          decimalMatch[1];
      } else {
        value =
          value.replace(
            /[.,]/g,
            ""
          );
      }

      var number = Number(value);

      if (!Number.isFinite(number)) {
        return null;
      }

      var cents =
        Math.round(number * 100);

      return Number.isSafeInteger(cents)
        ? cents
        : null;
    }

    renderPrices() {
      var base =
        Number(
          this.config.basePrice
        );

      [1, 2, 4, 6].forEach(
        function (quantity) {
          var total =
            this.prices[quantity];

          var each =
            total / quantity;

          var saving =
            base * quantity -
            total;

          this.querySelectorAll(
            '[data-total="' +
            quantity +
            '"]'
          ).forEach(
            function (node) {
              node.textContent =
                this.formatMoney(total);
            }.bind(this)
          );

          this.querySelectorAll(
            '[data-each="' +
            quantity +
            '"]'
          ).forEach(
            function (node) {
              node.textContent =
                this.formatMoney(each);
            }.bind(this)
          );

          var save =
            this.querySelector(
              '[data-save="' +
              quantity +
              '"]'
            );

          if (save) {
            if (saving > 0) {
              save.textContent =
                "Save " +
                this.formatMoney(saving);

              save.hidden = false;
            } else {
              save.hidden = true;
            }
          }
        }.bind(this)
      );
    }

    formatMoney(cents) {
      return this.money.format(
        Number(cents) / 100
      );
    }

    hideNativeControls() {
      var info =
        this.closest(
          '[id^="ProductInfo-"]'
        );

      if (!info) return;

      var selectors = [
        "product-form",
        "variant-selects",
        "variant-radios",
        ".product-form__quantity",
        '[id^="price-"]',
        ".product__tax",
        "shopify-payment-terms"
      ];

      info
        .querySelectorAll(
          selectors.join(",")
        )
        .forEach(
          function (element) {
            if (
              this.contains(element)
            ) {
              return;
            }

            element.classList.add(
              "ltbc40-native-hidden"
            );

            this.hiddenNative.add(
              element
            );
          }.bind(this)
        );

      this.hideVitalsVisual();
    }

    restoreNativeControls() {
      this.hiddenNative.forEach(
        function (element) {
          element.classList.remove(
            "ltbc40-native-hidden"
          );
        }
      );

      this.hiddenNative.clear();

      document.body.classList.remove(
        "ltbc40-picker-ready"
      );
    }

    enableButtons() {
      this.querySelectorAll(
        "[data-buy]"
      ).forEach(
        function (button) {
          button.disabled = false;
        }
      );
    }

    disableButtons() {
      this.querySelectorAll(
        "[data-buy]"
      ).forEach(
        function (button) {
          button.disabled = true;
        }
      );
    }

    buildItems(quantity) {
      var group =
        quantity === 1
          ? "single"
          : quantity === 2
            ? "pair"
            : quantity === 4
              ? "four"
              : quantity === 6
                ? "six"
                : null;

      if (!group) {
        throw new Error(
          "Choose 1, 2, 4 or 6 calendars."
        );
      }

      var counts = {};

      this.selections[group].forEach(
        function (variantId) {
          var variant =
            this.getVariant(
              variantId
            );

          if (
            !variant ||
            !variant.available
          ) {
            throw new Error(
              "One of your selected covers is no longer available."
            );
          }

          var key =
            String(variantId);

          counts[key] =
            (counts[key] || 0) + 1;
        }.bind(this)
      );

      var items =
        Object.keys(counts).map(
          function (id) {
            return {
              id: Number(id),
              quantity: counts[id]
            };
          }
        );

      if (this.addonSelected) {
        if (
          !this.config.addon ||
          !this.config.addon.available
        ) {
          throw new Error(
            "The dog clip offer is currently unavailable."
          );
        }

        items.push({
          id: Number(
            this.config.addon.variantId
          ),
          quantity: 1
        });
      }

      return items;
    }

    normalizedRoot() {
      var root =
        this.config.rootUrl ||
        "/";

      if (
        root.charAt(
          root.length - 1
        ) !== "/"
      ) {
        root += "/";
      }

      return root;
    }

    async request(path, options) {
      var controller =
        new AbortController();

      var timeout =
        setTimeout(
          function () {
            controller.abort();
          },
          15000
        );

      try {
        var response =
          await fetch(
            this.normalizedRoot() +
            path,

            Object.assign(
              {
                credentials:
                  "same-origin",

                cache:
                  "no-store",

                headers: {
                  Accept:
                    "application/json",

                  "Content-Type":
                    "application/json"
                },

                signal:
                  controller.signal
              },

              options || {}
            )
          );

        var data =
          await response.json();

        if (!response.ok) {
          throw new Error(
            typeof data.description ===
            "string"
              ? data.description
              : "Please review your cart."
          );
        }

        return data;
      } finally {
        clearTimeout(timeout);
      }
    }

    async verifyProduct() {
      var product =
        await this.request(
          "products/" +
          encodeURIComponent(
            this.config.handle
          ) +
          ".js"
        );

      if (
        toStringId(product.id) !==
        toStringId(
          this.config.productId
        )
      ) {
        throw new Error(
          "Product information changed. Refresh the page."
        );
      }

      this.selections.single
        .concat(
          this.selections.pair,
          this.selections.four,
          this.selections.six
        )
        .forEach(
          function (variantId) {
            var remote =
              product.variants.find(
                function (variant) {
                  return (
                    toStringId(
                      variant.id
                    ) ===
                    toStringId(
                      variantId
                    )
                  );
                }
              );

            if (
              !remote ||
              !remote.available ||
              Number(remote.price) !==
              Number(
                this.config.basePrice
              )
            ) {
              throw new Error(
                "A calendar cover or price changed. Refresh the page."
              );
            }
          }.bind(this)
        );
    }

    async verifyAddon() {
      if (!this.addonSelected) {
        return;
      }

      var addon =
        await this.request(
          "products/" +
          encodeURIComponent(
            this.config.addon.handle
          ) +
          ".js"
        );

      if (
        toStringId(addon.id) !==
        toStringId(
          this.config.addon.productId
        )
      ) {
        throw new Error(
          "The dog clip offer changed. Refresh the page."
        );
      }

      var variant =
        addon.variants.find(
          function (item) {
            return (
              toStringId(item.id) ===
              toStringId(
                this.config.addon.variantId
              )
            );
          }.bind(this)
        );

      if (
        !variant ||
        !variant.available ||
        Number(variant.price) !==
        Number(
          this.config.addon.basePrice
        )
      ) {
        throw new Error(
          "The dog clip offer changed. Refresh the page."
        );
      }
    }

    productQuantity(cart, productId) {
      return cart.items.reduce(
        function (total, item) {
          return (
            toStringId(
              item.product_id
            ) ===
            toStringId(productId)
              ? total +
                Number(item.quantity)
              : total
          );
        },
        0
      );
    }

    productTotal(cart, productId) {
      return cart.items.reduce(
        function (total, item) {
          return (
            toStringId(
              item.product_id
            ) ===
            toStringId(productId)
              ? total +
                Number(
                  item.final_line_price
                )
              : total
          );
        },
        0
      );
    }

    async buy(quantity) {
      if (
        !this.ready ||
        this.busy ||
        [1, 2, 4, 6].indexOf(
          quantity
        ) === -1
      ) {
        return;
      }

      this.busy = true;
      this.disableButtons();

      this.showStatus(
        "Preparing your calendars…",
        false
      );

      try {
        await this.verifyProduct();
        await this.verifyAddon();

        var before =
          await this.request(
            "cart.js"
          );

        if (
          toStringId(
            before.currency
          ) !==
          toStringId(
            this.config.currency
          )
        ) {
          throw new Error(
            "Your shopping currency changed. Refresh the page."
          );
        }

        if (
          this.productQuantity(
            before,
            this.config.productId
          ) > 0
        ) {
          throw new Error(
            "You already have this calendar in your cart. Review your cart before adding another bundle."
          );
        }

        if (
          this.addonSelected &&
          this.productQuantity(
            before,
            this.config.addon.productId
          ) > 0
        ) {
          throw new Error(
            "The dog clip set is already in your cart. Review your cart before adding another."
          );
        }

        var items =
          this.buildItems(
            quantity
          );

        await this.request(
          "cart/add.js",
          {
            method: "POST",
            body: JSON.stringify({
              items: items
            })
          }
        );

        var after =
          await this.request(
            "cart.js"
          );

        if (
          this.productQuantity(
            after,
            this.config.productId
          ) !== quantity
        ) {
          throw new Error(
            "Please review your cart before checkout."
          );
        }

        var expectedCalendarTotal =
          this.prices[quantity];

        var actualCalendarTotal =
          this.productTotal(
            after,
            this.config.productId
          );

        if (
          actualCalendarTotal >
          expectedCalendarTotal + 2
        ) {
          throw new Error(
            "The calendar discount needs review. Please check your cart before checkout."
          );
        }

        if (this.addonSelected) {
          if (
            this.productQuantity(
              after,
              this.config.addon.productId
            ) !== 1
          ) {
            throw new Error(
              "Please review the dog clip set in your cart."
            );
          }

          var actualAddonTotal =
            this.productTotal(
              after,
              this.config.addon.productId
            );

          if (
            actualAddonTotal >
            this.addonExpectedTotal + 2
          ) {
            throw new Error(
              "The dog clip discount needs review. Please check your cart before checkout."
            );
          }
        }

        this.showStatus(
          "Your calendars are ready. Opening checkout…",
          false
        );

        window.location.assign(
          this.normalizedRoot() +
          "checkout"
        );

      } catch (error) {
        this.busy = false;
        this.enableButtons();

        this.showStatus(
          error.message ||
          "We couldn't add your calendars. Please try again.",
          true
        );
      }
    }

    showStatus(message, showCart) {
      var status =
        this.querySelector(
          "[data-status]"
        );

      if (status) {
        status.textContent =
          message || "";

        status.hidden =
          !message;
      }

      var cartLink =
        this.querySelector(
          "[data-cart-link]"
        );

      if (cartLink) {
        cartLink.hidden =
          !showCart;

        cartLink.href =
          this.config.cartUrl ||
          "/cart";
      }
    }

    clearStatus() {
      this.showStatus("", false);
    }

    fail(message) {
      this.showStatus(
        message,
        false
      );

      this.restoreNativeControls();
    }

    disconnectedCallback() {
      this.removed = true;

      clearTimeout(
        this.priceTimer
      );

      if (this.observer) {
        this.observer.disconnect();
      }

      if (this.changeHandler) {
        this.removeEventListener(
          "change",
          this.changeHandler
        );
      }

      if (this.clickHandler) {
        this.removeEventListener(
          "click",
          this.clickHandler
        );
      }

      this.restoreNativeControls();
      this.started = false;
    }
  }

  if (
    !customElements.get(
      "ltbc-calendar-picker-v40"
    )
  ) {
    customElements.define(
      "ltbc-calendar-picker-v40",
      LTBCCalendarPickerV40
    );
  }
})();